import { CommentaireResponseDto } from 'lib_api/lib/api/gen';

export function sortCommentaireListDtoByDateDesc(
  commentairesDto: CommentaireResponseDto[],
): CommentaireResponseDto[] {
  return commentairesDto.sort((a, b) => {
    return new Date(b.dateAjout).getTime() - new Date(a.dateAjout).getTime();
  });
}
